import AboutPreview from "../components/AboutPreview";
import ContactCTA from "../components/ContactCTA";
import FAQPreview from "../components/FAQPreview";
import HeroSlider from "../components/HeroSlider";
import Partners from "../components/Partners";
import ProcessSection2 from "../components/ProcessSection2";
import ServicesPreview from "../components/ServicesPreview";
import SocialMediaSection from "../components/SocialMediaSection";
import Stats from "../components/Stats";
import Testimonials from "../components/Testimonials";
import WhatsAppButton from "../components/WhatsAppButton";
import WhyUsSection from "../components/WhyUsSection";

export default function Home() {
  return (
    <>
      <HeroSlider />
      <Stats />
      <AboutPreview />
      <ServicesPreview />
      <Partners />
      <WhyUsSection />
      <ProcessSection2 />
      <Testimonials />
      <FAQPreview />
      <SocialMediaSection />
      <ContactCTA />
      
    </>
  );
}